<script>

export default {
  name: 'CommonJs',
  data () {
    return {
      name: '',
      open: false,
      uid: this.$firebase.auth().currentUser
    }
  },
  methods: {
  }
}
// var user = this.$firebase.auth().currentUser
// if (user) {
//   // User is signed in.
//   alert(user)
// } else {
//   // No user is signed in.
//   alert('No user is signed in.')
// }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/js/common.vue